import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

// Config
import { Config } from '../../providers/config/config';

// Helpers
import { HelperService } from '../../providers/helpers/helper-service';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json; charset=UTF-8;'
  })
}

@Injectable()
export class FilesService {
  constructor( 
    public http: HttpClient,
    public helperService: HelperService
  ) {}

  saveFileEntry( file )
  {
    return this.http.post( Config.API_ROOT_INSTRUCTORS + 'files', JSON.stringify(file), httpOptions );
  }

  deleteFile( fileId )
  {
    return this.http.delete( Config.API_ROOT_INSTRUCTORS + 'files/' + fileId );
  }
}


// WEBPACK FOOTER //
// ./src/providers/files/files-service.ts